const Debug = require('debug');
const diff = require('immutablediff');
const debug = Debug('svtse:middleware:logging:debug');
const trace = Debug('svtse:middleware:logging:redux');
const logger = (store) => (next) => (action) => {
	if(Debug.enabled(trace.namespace)) {
		const previous = store.getState().toJS();
		const result = next(action);
		const	current = store.getState().toJS();
		trace('ACTION %s=%o diff=%o',action.type, action, diff(previous, current).toJS() );
		//trace('ACTION %s=%o previous=%o current=%o',action.type, action, previous, current);
		return result;
	} else if(Debug.enabled(debug.namespace)) {
		debug('ACTION %s=%o',action.type, action);
		return next(action);
	} else {
		return next(action);
	}
};
export default logger;



/** WEBPACK FOOTER **
 ** ./app/middleware/logging.js
 **/